import React, { useRef, useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../config";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css"; // Import Tagify CSS

const AdsGroup = () => {
  const [adsGroup, setAdsGroup] = useState([]);
  const [ads, setAds] = useState([]); // Store fetched ads from the API
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    ad_ids: [],
    ads_group_name: "",
  });
  const [tagifyInstance, setTagifyInstance] = useState(null); // Store Tagify instance

  const inputAdsTagRef = useRef(null); // Ref for the input field
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  // Fetch ads data from the API
  const fetchEventAds = async () => {
    try {
      const response = await axiosAPI.get(`/api/ads/get-event-ads`);
      const adsData = response.data;

      setAds(adsData); // Set the ads data to state
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  // Function to fetch adsGroup data from the API
  const fetchEventAdsGroups = async () => {
    try {
      const response = await axiosAPI.get(
        `/api/ads-group/get-event-ads-groups`
      );
      const adsData = response.data;

      setAdsGroup(adsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching adsGroup:", error);
      setLoading(false);
    }
  };

  // Fetch ads when the component mounts
  useEffect(() => {
    fetchEventAds();
    fetchEventAdsGroups();
  }, []);

  // functions
  const resetForm = () => {
    setFormData({
      id: "",
      ad_ids: [],
      ads_group_name: "",
    });
  };

  // impliment Tagify input field-START

  // Update formData on add/remove tag
  const updateFormDataForAds = (ad_name, action) => {
    const matchingItem = ads.find((item) => item.ad_name === ad_name);
    const matchingItemId = matchingItem ? matchingItem.id : null;

    console.log({ matchingItemId });

    if (matchingItemId) {
      setFormData((prevFormData) => {
        const updatedAddIds =
          action === "add"
            ? [...prevFormData.ad_ids, matchingItemId]
            : prevFormData.ad_ids.filter((id) => id !== matchingItemId);

        return {
          ...prevFormData,
          ad_ids: updatedAddIds,
        };
      });
    }
  };

  useEffect(() => {
    if (inputAdsTagRef.current) {
      const tagify = new Tagify(inputAdsTagRef.current, {
        whitelist: ads.map((item) => item.ad_name), // Use ad_name as the tag value
        enforceWhitelist: true, // Only allow tags from the whitelist
        dropdown: {
          enabled: 0, // Show all suggestions on focus
          searchKeys: ["ad_name"], // Keys to search in whitelist objects
          mode: "all", // Ensure the dropdown mode is set
        },
      });

      // Store the Tagify instance to later manipulate
      setTagifyInstance(tagify);

      tagify.on("add", (e) => updateFormDataForAds(e.detail.data.value, "add"));
      tagify.on("remove", (e) =>
        updateFormDataForAds(e.detail.data.value, "remove")
      );

      return () => {
        tagify.destroy(); // Cleanup to prevent memory leaks
      };
    }
  }, [ads]);

  // Function to remove all tags (clear all tags)
  const removeDefaultTags = () => {
    if (inputAdsTagRef.current) {
      // Remove all tags from the input field
      tagifyInstance.removeAllTags();
    }
  };

  const openAddModal = () => {
    removeDefaultTags();

    // reset form
    resetForm();

    // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
    showModal("newGroupModal");
  };

  // Function to set default tags
  const setDefaultTags = (ad_ids) => {
    const defaultTags = ads
      .filter((ad) => ad_ids.includes(ad.id))
      .map((ad) => ad.ad_name); // Map IDs to ad_names

    if (inputAdsTagRef.current) {
      tagifyInstance.removeAllTags(); // Remove any existing tags (optional)
      tagifyInstance.addTags(defaultTags); // Add the new tags
    }
  };

  const openEditModal = (adId) => {
    const adToEdit = adsGroup.find((ad) => ad.id === adId);

    if (adToEdit) {
      // removeDefaultTags();
      // // reset form
      // resetForm();

      // Get ad_ids from the selected ad group
      const adIds = adToEdit.ads
        .filter((ad) => ad.ads_id) // Filter out any invalid ads (e.g., where ads_id or ad_name is null)
        .map((ad) => ad.ads_id); // Get the ads_id values

      console.log({ formData });

      // Set formData with the details of the selected ad
      setFormData({
        id: adToEdit.id, // Set the ad ID
        ads_group_name: adToEdit.ads_group_name || "", // Set the ad group name
        ad_ids: [], // Set ad_ids array for formData
      });

      console.log({ formData });

      console.log({ adIds });

      setDefaultTags(adIds);

      // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
      showModal("newGroupModal");
    }
  };

  // impliment Tagify input field-END

  // useEffect(() => {
  //   console.log({ formData });
  // }, [formData]);

  // Function to handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    console.log({ formData });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    // Validate required fields
    if (!formData.ads_group_name) {
      // console.log("Add Name is mandatory! Please fill the field.");
      window.notifyMessage(
        "Error",
        "Add Name is mandatory! Please fill the field.",
        "danger"
      );
      setIsSubmitting(false);
      return; // Prevent form submission if any field is missing
    }

    if (!formData.ad_ids || formData.ad_ids.length === 0) {
      // console.log("Add IDs is mandatory! Please fill the field.");

      window.notifyMessage(
        "Error",
        "Ads is mandatory! Please fill the field.",
        "danger"
      );
      setIsSubmitting(false);
      return; // Prevent form submission if any field is missing
    }

    const updatedFormData = {
      ...formData,
    };

    try {
      const requestUrl = formData.id
        ? `/api/ads-group/update-event-ads-group/${formData.id}` // Edit existing event
        : `/api/ads-group/add-event-ads-group`; // Add new event

      // Set the correct HTTP method (POST for adding, PUT for editing)
      const httpMethod = formData.id ? "PUT" : "POST";

      // Make the API call to add or edit the event
      const response = await axiosAPI({
        method: httpMethod,
        url: requestUrl,
        data: updatedFormData,
      });

      if (formData.id) {
        window.notifyMessage(
          "Success",
          "Ads Program updated successfully",
          "success"
        );
      } else {
        window.notifyMessage(
          "Success",
          "Ads Program added successfully",
          "success"
        );
      }

      setIsSubmitting(false);
      resetForm();
      hideModal("newGroupModal");
      // Reload the events data (optional, depending on your app)
      fetchEventAdsGroups();
    } catch (error) {
      // Check if it's an error from the API response
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger"
        );
        setIsSubmitting(false);
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
        setIsSubmitting(false);
      }
    }
  };

  const handleDelete = async (adId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      await axiosAPI.delete(`/api/ads-group/delete-event-ads-group/${adId}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchEventAdsGroups();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  // if (!pageUserId) {
  //   console.error("User not found!");
  //   return;
  // }

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div className="d-flex"></div>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              <i className="far fa-plus-square me-2"></i>
              New Program
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newGroupModal"
          tabIndex="-1"
          aria-labelledby="newGroupModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="newGroupModalLabel">
                  {formData.id ? "Edit Program" : "Add New Program"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body bg-light">
                <form onSubmit={handleSubmit}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row mt-3">
                        {/* Program Name */}
                        <div className="col-md-12 mb-3">
                          <label
                            htmlFor="ads_group_name"
                            className="form-label"
                          >
                            Program Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ads_group_name"
                            value={formData.ads_group_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        {/* Add Ids */}
                        <div className="col-md-12 mb-3">
                          <label htmlFor="ad_ids" className="form-label">
                            Ads
                          </label>
                          <input
                            ref={inputAdsTagRef}
                            type="text"
                            className="form-control"
                            id="ad_ids"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={isSubmitting} // Disable the button while submitting
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : formData.id ? (
                      "Save Program"
                    ) : (
                      "Add Program"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title">
                      All Programs (<span>{adsGroup.length}</span>)
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover basic-datatables">
                    <thead>
                      <tr>
                        <th>Program Name</th>
                        <th>Ads</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        adsGroup.map((ad) => {
                          // Get the valid ads (ads with a non-null ad_name)
                          const validAds = ad.ads.filter(
                            (adItem) => adItem.ad_name
                          );

                          // Determine the maximum number of badges to show
                          const displayedAds = validAds.slice(0, 3); // Get the first 3 valid ads
                          const extraAds =
                            validAds.length - displayedAds.length; // Calculate how many extra ads there are

                          return (
                            <tr key={ad.id}>
                              <td>{ad.ads_group_name}</td>
                              <td>
                                {displayedAds.map((adItem) => (
                                  <span
                                    key={adItem.ads_id}
                                    className="badge rounded-pill bg-light text-dark me-1"
                                  >
                                    {adItem.ad_name}
                                  </span>
                                ))}
                                {extraAds > 0 && (
                                  <span className="badge rounded-pill bg-light text-dark">
                                    ... +{extraAds} more
                                  </span>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(ad.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(ad.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdsGroup;
